import React, { type ReactElement } from 'react';
import TooltipItem from 'atom-components/tooltip-item';
import { systemError } from 'feature-components/system-error-alert';
import type { PartialOrganisationUserWithPartialUser } from 'services/assist-api/entities/customer-user/types';

type Props = {
  organisationUser: PartialOrganisationUserWithPartialUser | undefined;
  bringAttentionTo?: boolean;
};

export const userDetailsNotFound = 'User details not found.';

export default function FullName({ organisationUser, bringAttentionTo }: Props): ReactElement {
  if (
    !organisationUser?.user.firstname ||
    !organisationUser?.user.lastname ||
    !organisationUser?.user.username
  ) {
    return <b>{systemError(userDetailsNotFound)}</b>;
  }

  const fullName = `${organisationUser.user.firstname} ${organisationUser.user.lastname}`;

  return (
    <TooltipItem tooltip={`@${organisationUser.user.username}`}>
      {bringAttentionTo ? <b>{fullName}</b> : <span>{fullName}</span>}
    </TooltipItem>
  );
}
